/**
 * Centralized API Configuration
 * All API-related constants and utilities should be imported from this file.
 */

// Backend URL from environment variable
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Base API path with /api prefix
export const API = `${BACKEND_URL}/api`;

// API Endpoints - Single source of truth for all API routes
export const ENDPOINTS = {
  // Scanning & Reports
  SCAN: `${API}/scan`,
  REPORT: (barcode) => `${API}/report/${barcode}`,
  REPORT_GENERATE: `${API}/report/generate`,
  REPORT_REGENERATE: (barcode) => `${API}/report/${barcode}/regenerate`,
  
  // Repository
  REPOSITORY_STATS: `${API}/repository/stats`,
  REPOSITORY_REPORTS: (limit = 20, sort = 'popular') => `${API}/repository/reports?limit=${limit}&sort=${sort}`,
  REPOSITORY_SEARCH: (query) => `${API}/repository/search?q=${encodeURIComponent(query)}`,
  
  // Contributions
  CONTRIBUTIONS: `${API}/contributions`,
  CONTRIBUTIONS_STATS: `${API}/contributions/stats`,
  CONTRIBUTIONS_LIST: (limit = 20) => `${API}/contributions?limit=${limit}`,
  
  // Donations
  DONATE_CHECKOUT: `${API}/donate/checkout`,
  DONATE_STATUS: (sessionId) => `${API}/donate/status/${sessionId}`,
  
  // Data Sources
  DATA_SOURCES: `${API}/data-sources`,
  
  // Category/Taxonomy
  CATEGORY_TAXONOMY: `${API}/category/taxonomy`,
  CATEGORY_SUGGESTIONS: (query) => `${API}/category/suggestions?q=${encodeURIComponent(query)}`,
  
  // Product Search
  SEARCH_PRODUCT: `${API}/search-product`,
  EXTRACT_URL: `${API}/extract-url`,

  // Action Pathways
  ACTION_PATHWAYS: `${API}/actions/pathways`,
  ACTION_CATEGORIES: `${API}/actions/categories`,

  // Admin (requires X-Admin-Key header)
  ADMIN_CONTRIBUTIONS_STATS: `${API}/admin/contributions/stats`,
  ADMIN_CONTRIBUTIONS_PENDING: `${API}/admin/contributions/pending`,
  ADMIN_CONTRIBUTION: (id) => `${API}/admin/contributions/${id}`,
  ADMIN_TIER_STATS: `${API}/admin/reports/tier-stats`,
  ADMIN_REPORTS_BY_TIER: (tier, limit = 20) => `${API}/admin/reports/by-tier/${tier}?limit=${limit}`,
};

